import { useEffect, useRef } from 'react';
import "../styles/Loading.css"

const TAU = Math.PI * 2;
const ease = t => 0.5 - 0.5 * Math.cos(t * TAU);

function pt(cx, cy, r, deg) {
  const a = (deg - 90) * Math.PI / 180;
  return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
}

const P = {
  p: [52,  92,  125],
  m: [107, 147, 184],
  a: [102, 204, 255],
  s: [167, 222, 223],
};
const col = ([r, g, b], a) => `rgba(${r},${g},${b},${a.toFixed(3)})`;

function drawRosette(canvas, phase) {
  const ctx = canvas.getContext('2d');
  const W = canvas.width;
  const cx = W / 2, cy = W / 2;
  ctx.clearRect(0, 0, W, W);

  const R  = W * 0.44;
  const Rs = W * 0.36;
  const Re = W * 0.26;
  const Ri = W * 0.16;

  for (let i = 0; i < 8; i++) {
    const baseAngle = i * 45;
    const pb = ease((phase + i / 8) % 1);
    const warm = i % 2 === 0;

    const tip = pt(cx, cy, R,  baseAngle);
    const sR  = pt(cx, cy, Rs, baseAngle + 18);
    const eR  = pt(cx, cy, Re, baseAngle + 11);
    const H   = pt(cx, cy, Ri, baseAngle);
    const eL  = pt(cx, cy, Re, baseAngle - 11);
    const sL  = pt(cx, cy, Rs, baseAngle - 18);

    ctx.beginPath();
    ctx.moveTo(...tip);
    ctx.lineTo(...sR);
    ctx.lineTo(...eR);
    ctx.lineTo(...H);
    ctx.lineTo(...eL);
    ctx.lineTo(...sL);
    ctx.closePath();

    ctx.fillStyle   = col(warm ? P.s : P.m, 0.03 + pb * 0.22);
    ctx.fill();
    ctx.strokeStyle = col(warm ? P.m : P.p, 0.08 + pb * 0.60);
    ctx.lineWidth   = 0.5 + pb * 0.9;
    ctx.lineJoin    = 'round';
    ctx.stroke();
  }

  const gb = ease(phase);
  [0, 45].forEach(offset => {
    const sq = [0, 90, 180, 270].map(a => pt(cx, cy, Ri * 1.05, a + offset));
    ctx.beginPath();
    sq.forEach(([x, y], j) => j === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y));
    ctx.closePath();
    ctx.fillStyle   = col(P.a, 0.04 + gb * 0.06);
    ctx.fill();
    ctx.strokeStyle = col(P.m, 0.12 + gb * 0.12);
    ctx.lineWidth   = 0.4;
    ctx.lineJoin    = 'round';
    ctx.stroke();
  });
}

export default function PageLoader() {
  const canvasRef = useRef(null);
  const rafRef    = useRef(null);
  const t0Ref     = useRef(null);
  const CYCLE     = 2400;

  useEffect(() => {
    const tick = ts => {
      if (!t0Ref.current) t0Ref.current = ts;
      const phase = ((ts - t0Ref.current) % CYCLE) / CYCLE;
      if (canvasRef.current) drawRosette(canvasRef.current, phase);
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  return (
    <div className="page-loader">
      <canvas ref={canvasRef} width={200} height={200} />
      <span className="page-loader__text">Loading</span>
    </div>
  );
}